import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af9f9b66")

_pushScopeId("data-v-af9f9b66")
const _hoisted_1 = { class: "pdf-viewer-app" }
const _hoisted_2 = { class: "pdf-toolbar" }
const _hoisted_3 = { class: "pdf-title-area" }
const _hoisted_4 = {
  role: "heading",
  "aria-level": 3,
  class: "toolbar-title"
}
const _hoisted_5 = {
  key: 0,
  class: "pdf-tool-sets"
}
const _hoisted_6 = { class: "pdf-tool-item separator page-number" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "page-number-separator" }, "of", -1)
const _hoisted_8 = { class: "pdf-tool-item zoom-level" }
const _hoisted_9 = { class: "button-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20px",
  viewBox: "0 -960 960 960",
  width: "20px",
  fill: "#555"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400ZM280-540v-80h200v80H280Z" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20px",
  viewBox: "0 -960 960 960",
  width: "20px",
  fill: "#555"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Zm-40-60v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z" })
], -1)
const _hoisted_12 = { class: "pdf-tool-item" }
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "18px",
  width: "18px",
  viewBox: "0 -960 960 960",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M120-120v-720h80v720h-80Zm640 0v-720h80v720h-80ZM280-440v-80h80v80h-80Zm160 0v-80h80v80h-80Zm160 0v-80h80v80h-80Z" })
], -1)
const _hoisted_14 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "18px",
  width: "18px",
  viewBox: "0 -960 960 960",
  fill: "currentColor"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("path", { d: "M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "rotate",
  xmlns: "http://www.w3.org/2000/svg",
  height: "18px",
  width: "18px",
  viewBox: "0 -960 960 960",
  fill: "currentColor"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("path", { d: "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z" }, null, -1)
const _hoisted_18 = { class: "close-button-wrapper" }
const _hoisted_19 = {
  ref: "pageContainer",
  class: "page-container position-absolute"
}
const _hoisted_20 = {
  key: 0,
  class: "preview-loader-wrapper"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "loader-indicator" }, null, -1)
const _hoisted_22 = {
  ref: "viewer",
  class: "pdfViewer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.file.name), 1)
      ]),
      (!_ctx.showLoader)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("input", {
                class: "page-input",
                value: _ctx.currentPage,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.debouncedApplyPageChange($event)))
              }, null, 40, ["value"]),
              _hoisted_7,
              _createVNode("span", null, _toDisplayString(_ctx.totalPage), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("button", {
                  class: "toolbar-btn zoom-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adjustZoom(-30))),
                  title: "Zoom Out"
                }, [
                  _hoisted_10
                ]),
                _createVNode("input", {
                  value: _ctx.zoomLevel,
                  placeholder: "Zoom",
                  class: "zoom-input",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.debouncedScaleChange($event)))
                }, null, 40, ["value"]),
                _createVNode("button", {
                  class: "toolbar-btn zoom-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.adjustZoom(30))),
                  title: "Zoom In"
                }, [
                  _hoisted_11
                ])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("button", {
                class: ["toolbar-btn fit-content-button", { 'active': _ctx.enableFitWidth }],
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleFitWidth()))
              }, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('default.file_preview.fit_width')), 1)
              ], 2),
              _createVNode("button", {
                class: "toolbar-btn download-button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadFile()))
              }, [
                (!_ctx.downloadInProgress)
                  ? (_openBlock(), _createBlock("svg", _hoisted_14, [
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.downloadInProgress)
                  ? (_openBlock(), _createBlock("svg", _hoisted_16, [
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('default.details_page.download')), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_18, [
        _renderSlot(_ctx.$slots, "closeButton", {}, undefined, true)
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      (_ctx.showLoader)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _hoisted_21
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_22, null, 512)
    ], 512)
  ]))
})